var map = {
	"./BuyingService": 18,
	"./BuyingService.js": 18,
	"./CatalogLoaderService": 37,
	"./CatalogLoaderService.js": 37,
	"./CatalogService": 20,
	"./CatalogService.js": 20,
	"./CategoryService": 35,
	"./CategoryService.js": 35,
	"./CrmService": 19,
	"./CrmService.js": 19,
	"./FavoriteService": 48,
	"./FavoriteService.js": 48,
	"./FeedbacksService": 36,
	"./FeedbacksService.js": 36,
	"./GuideService": 91,
	"./GuideService.js": 91,
	"./IsFavoriteService": 90,
	"./IsFavoriteService.js": 90,
	"./ItemService": 210,
	"./ItemService.js": 210,
	"./RequestService": 211,
	"./RequestService.js": 211,
	"./SphinxCatalog": 120,
	"./SphinxCatalog.js": 120,
	"./UnloadingService": 38,
	"./UnloadingService.js": 38,
	"./api": 16,
	"./api.js": 16
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 438;
module.exports = webpackAsyncContext;